import { useMemo } from 'react';

import { Navigate } from 'react-router-dom';

import { useNavigateToAuth } from '../../hooks/useNavigateToAuth/useNavigateToAuth';

type NavigateToAuthProps = {
  page: 'sign-in' | 'sign-up';
  redirect?: string;
  additionalParams?: Record<string, string>;
};

const NavigateToAuth = ({ page, redirect, additionalParams }: NavigateToAuthProps) => {
  const { setAuthRedirection } = useNavigateToAuth();
  const searchParams = useMemo(
    () => setAuthRedirection({ redirect, additionalParams }),
    [setAuthRedirection, redirect, additionalParams]
  );
  return <Navigate to={`/${page}?${searchParams.toString()}`} replace />;
};

export { NavigateToAuth };
